<template>
<w-sliding-popup ref="slidingPopup" title="즐겨찾기 설정" width="470px" :default-content="false" @close="close">
  <div class="tab-wrapper body-content-no-scroll" style="height:100%; padding: 10px 25px 25px  !important" slot="content">
    <el-tabs slot="content" style="height:100%;" v-model="activeTab">
      <el-tab-pane label="즐겨찾기 편집" name="editBookmark">
        <w-edit-bookmark ref="editBookmark" style="margin-top: -10px"></w-edit-bookmark>
      </el-tab-pane>
      <el-tab-pane label="즐겨찾기 정리" name="cleanupBookmark">
        <div style="margin-top: -10px">
          <el-steps :active="activeStep" finish-status="success">
            <el-step title="조건 설정"></el-step>
            <el-step title="즐겨찾기 삭제"></el-step>
          </el-steps>
          <div v-show="activeStep === 1">
            <div :class="[$style.info, 'mr-b10']">
              총 <span :class="$style.cnt">{{currntBookmarkCnt}}</span>개의 즐겨찾기가 있습니다. 삭제할 조건을 선택해주세요.
            </div>
            <hr class="mr-b10"/>
            <div class="edit_bookmark">
              <el-checkbox-group v-model="checkedDeleteInfo">
                <ul :class="$style['condition-list']">
                  <li>
                    <el-checkbox label="duplicatePath">중복된 경로</el-checkbox>
                  </li>
                  <li>
                      <el-checkbox label="nonePath">존재하지 않는 경로</el-checkbox>
                  </li>
                  <li>
                    <el-checkbox label="pastLastVisit">
                      <span class="mr-r4">
                        마지막 방문일로부터
                      </span>
                      <el-input-number style="width:80px;" v-model="selectLastVisit" controls-position="right" :min="1"></el-input-number>
                      <span>
                        일 이상 지난 즐겨찾기
                      </span>
                    </el-checkbox>
                  </li>
                  <li>
                      <el-checkbox label="emptyFolder">빈 폴더</el-checkbox>
                  </li>
                </ul>
             </el-checkbox-group>
            </div>
          </div>
          <div v-show="activeStep === 2" v-loading="isLoading">
            <div :class="[$style.info, 'mr-b10']">
              <span :class="$style.cnt">{{bookmarkCnt}}</span>개의 즐겨찾기와 <span :class="$style.cnt">{{groupCnt}}</span>개의 폴더가 검색됐습니다.
              삭제된 즐겨찾기와 폴더는 복구할 수 없습니다.
            </div>
            <el-collapse class="collapse-mini" v-model="activeCollapse">
              <el-collapse-item v-for="item in deleteInfoCollapse" :key="item.conditionName" :name="item.conditionName" :title="item.label">
                <template slot="title">
                  <el-checkbox class="mr-l4 mr-r4" v-model="item.checked" @change="allCheckingCollapse(item)"></el-checkbox>
                  <span>
                    {{item.label}}
                  </span>
                </template>
                <el-checkbox-group v-model="checkedByCondition[item.conditionName]">
                  <ul>
                    <li v-for="(conditionInfo, index) in bookmarkByCondition[item.conditionName]" :key="index">
                      <el-checkbox class="mr-l4 mr-r4" v-if="item.conditionName !== 'duplicatePath'" :label="conditionInfo.bookmarkId">
                        {{conditionInfo.label}}
                      </el-checkbox>
                      <el-tooltip effect="dark" v-else >
                        <ul slot="content">
                          <li>이름 : {{conditionInfo.label}}</li>
                          <li>경로 : {{conditionInfo.bookmarkPath}}</li>
                          <li>마지막 방문일시 : {{dateFormmater(conditionInfo.lastVisitDatetime)}}</li>
                        </ul>
                        <el-checkbox class="mr-l4 mr-r4" :label="conditionInfo.bookmarkId">
                          {{conditionInfo.label}}
                        </el-checkbox>
                      </el-tooltip>
                    </li>
                  </ul>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <div slot="footer">
    <div v-if="activeTab === 'editBookmark'">
      <el-button class="mr-r4" type="solid" size="large" @click="saveBookmarkInfo">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
    <div v-else>
      <el-row slot="footer" type="flex" justify="end">
        <el-button v-if="activeStep === 1" class="mr-r4" type="solid" size="large" @click="onNextStep">다음</el-button>
      </el-row>
      <el-row v-if="activeStep === 2" class="title-bar" type="flex" justify="space-between">
        <el-button class="mr-r4" type="solid" size="large" @click="onPrevStep">이전</el-button>
        <el-button size="large" @click="cleanupBookmarkInfo">삭제</el-button>
      </el-row>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import moment from 'moment';
import { EMPTY_TEXT } from '@/utils/string';
import BookmarkAPI from '@/api/frame/bookmark';
import msgUtil from '@/utils/message';
import { isNil, find, isEmpty, uniqBy } from 'lodash';
import WEditBookmark from '../EditBookmark';

export default {
  name: 'WEditBookmarkPopup',
  components: {
    WEditBookmark,
  },
  data() {
    return {
      isLoading: false,
      activeStep: 1,
      activeTab: null,
      groupCnt: 0,
      bookmarkCnt: 0,
      currntBookmarkCnt: 0,
      activeCollapse: [],
      checkedDeleteInfo: [],
      deleteInfoCollapse: [],
      selectLastVisit: 30,
      searchCondition: {
        duplicatePath: {
          label: '중복된 경로',
          index: 1,
        },
        nonePath: {
          label: '존재하지 않는 경로',
          index: 2,
        },
        pastLastVisit: {
          label: '중복된 경로',
          index: 3,
        },
        emptyFolder: {
          label: '빈 폴더',
          index: 4,
        },
      },
      /**
       * 조회한 즐겨찾기 정보
       * @type {Object}
       */
      bookmarkByCondition: {
        duplicatePath: [],
        nonePath: [],
        pastLastVisit: [],
        emptyFolder: [],
      },
      checkedByCondition: {
        duplicatePath: [],
        nonePath: [],
        pastLastVisit: [],
        emptyFolder: [],
      },
    };
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          if (value === 'editBookmark') {
            this.activeStep = 1;
            this.initCondition();
            this.$nextTick(() => {
              this.$refs[value].loadData();
            });
          } else {
            this.loadData();
          }
        }
      },
    },
  },
  methods: {
    initCondition() {
      this.bookmarkByCondition = {
        duplicatePath: [],
        nonePath: [],
        pastLastVisit: [],
        emptyFolder: [],
      };
      this.checkedByCondition = {
        duplicatePath: [],
        nonePath: [],
        pastLastVisit: [],
        emptyFolder: [],
      };
    },
    open() {
      this.activeTab = 'editBookmark';
      this.$refs.slidingPopup.open();
    },
    close() {
      this.activeStep = 1;
      this.activeTab = null;
      this.$refs.slidingPopup.visible = false;
      this.checkedDeleteInfo = [];
      this.$emit('reload');
      this.$refs.editBookmark.init();
    },
    /**
     * 즐겨찾기 이름, 추가, 삭제 순서 변경을 수행한다.
     * @author yelim
     * @return {[type]} [description]
     */
    saveBookmarkInfo() {
      const editInfo = this.$refs[this.activeTab].getEditInfo();
      BookmarkAPI.editBookmarkInfo(editInfo).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '즐겨찾기 편집', true));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '즐겨찾기 편집', false));
        throw new Error(e);
      });
    },
    /**
     * 즐겨찾기 정리 next step
     * @author yelim
     * @param  {[type]} step [description]
     * @return {[type]}      [description]
     */
    onNextStep() {
      this.isLoading = true;
      if (this.checkedDeleteInfo.length > 0) {
        const collapseItem = [];
        this.activeCollapse = this.checkedDeleteInfo;
        this.checkedDeleteInfo.forEach((item) => {
          const checkedItem = {
            conditionName: item,
            label: this.searchCondition[item].label,
            index: this.searchCondition[item].index,
            checked: true,
          };
          if (item === 'pastLastVisit') {
            checkedItem.label = `마지막 방문일로부터 ${this.selectLastVisit}일 지난 즐겨찾기`;
            checkedItem.ndays = this.selectLastVisit;
          }
          collapseItem.push(checkedItem);
        });
        collapseItem.sort((a, b) => a.index - b.index);
        this.deleteInfoCollapse = collapseItem;
        BookmarkAPI.getBookmarkCleanupCondition(collapseItem).then((response) => {
          if (response.data.success) {
            const resultInfo = response.data.data;
            const keyInfo = Object.keys(resultInfo);
            const listForCounting = [];
            keyInfo.forEach((conditionItem) => {
              this.bookmarkByCondition[conditionItem] = resultInfo[conditionItem];
              listForCounting.push(resultInfo[conditionItem]);
              this.allCheckingCollapse({
                conditionName: conditionItem,
                checked: true,
              });
              if (conditionItem === 'emptyFolder') {
                this.groupCnt = resultInfo[conditionItem].length;
              }
            });
            if (!isEmpty(listForCounting)) {
              this.bookmarkCnt = uniqBy(listForCounting, 'bookmarkId')[0].length;
            }
            if (this.bookmarkCnt + this.groupCnt > 0) {
              this.activeStep = this.activeStep + 1;
            } else {
              this.$message(msgUtil.getCustomMsgData('정리할 즐겨찾기, 그룹이 없습니다'));
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 삭제 목록', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 삭제 목록', false));
          throw new Error(e);
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    },
    /**
     * 즐겨찾기 정리 prev step
     * @author yelim
     * @param  {[type]} step [description]
     * @return {[type]}      [description]
     */
    onPrevStep() {
      this.activeStep = this.activeStep - 1;
    },
    /**
     * 설정된 즐겨찾기의 정보를 로드한다.
     * @author yelim
     * @return {[type]} [description]
     */
    loadData() {
      BookmarkAPI.getBookmarkInfo().then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.currntBookmarkCnt = isNil(result.bookmarkCnt) ? 0 : result.bookmarkCnt;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 정보', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 정보', false));
        throw new Error(e);
      });
    },
    /**
     * collapse item 전체 선택 하는 경우
     * @author yelim
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    allCheckingCollapse(value) {
      const resultType = value.conditionName;
      const resultInfo = this.bookmarkByCondition[resultType];
      if (value.checked) {
        if (resultType !== 'emptyFolder') {
          resultInfo.forEach((conditionItem) => {
            this.checkedByCondition[resultType].push(conditionItem.bookmarkId);
          });
        } else {
          resultInfo.forEach((conditionItem) => {
            this.checkedByCondition[resultType].push(conditionItem.groupId);
          });
        }
      } else {
        this.checkedByCondition[resultType] = [];
      }
    },
    /**
     * 선택한 정리 조건에 따라 즐겨찾기 목록을 삭제한다.
     * @author yelim
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    cleanupBookmarkInfo() {
      const params = {};
      const searchResult = this.bookmarkByCondition;
      const checkedInfoList = this.checkedByCondition;
      const keyInfo = Object.keys(checkedInfoList);
      keyInfo.forEach((keyName) => {
        const resultData = [];
        if (!isEmpty(checkedInfoList[keyName])) {
          params[keyName] = resultData;
          checkedInfoList[keyName].forEach((idInfo) => {
            const findItem = find(searchResult[keyName], (item) => (keyName !== 'emptyFolder' ? item.bookmarkId : item.groupId) === idInfo);
            if (!isNil(findItem)) {
              resultData.push(findItem);
            }
          });
        }
      });
      BookmarkAPI.cleanupBookmarkInfo(params).then((response) => {
        if (response.data.success) {
          this.onPrevStep();
          this.loadData();
          this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '즐겨찾기 정리', true));
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '즐겨찾기 정리', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '즐겨찾기 정리', false));
        throw new Error(e);
      });
    },
    dateFormmater(value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
<style lang="scss">
.tab-wrapper {
  .el-tabs__content {
    margin-top: 15px;
    padding: 20px 15px 10px;
    border: 1px solid #dcdfe6;
    border-radius: 5px
  }
  .el-dialog__wrapper .el-tabs__active-bar {
    background: #5575fe !important
  }
}
.edit_bookmark {
  margin-left: 4px;
  li {
    font-family: 'malgun gothic', sans-serif;
    .el-checkbox__label {
      font-size: 11.5px !important;
      position: relative;
      top: 2px
    }
  }
}
</style>
<style lang="scss" module>
.info {
  .cnt {
    color: #1c768d;
    font-weight: 500;
    margin-left: 2px;
  }
}

.condition-list {
  li {
    padding: 2px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/EditBookmarkPopup.vue